import _State from '@states/_State.js';

const InvitedUsersState = _State('invitedUsers', 'setInvitedUsers', []);
export default InvitedUsersState;
